import { Component, inject } from '@angular/core';
import { MD_DIALOG_REF, MDDialogModule, MDDialogRef, MDIconComponent } from '@melodic-ui/components';

@Component({
	selector: 'lb-enrollment-timeline-v2-legend-dialog',
	standalone: true,
	imports: [MDDialogModule, MDIconComponent],
	templateUrl: './enrollment-timeline-legend-dialog.component.html',
	styleUrl: './enrollment-timeline-legend-dialog.component.scss'
})
export class EnrollmentTimelineV2LegendDialogComponent {
	private readonly dialogRef: MDDialogRef = inject(MD_DIALOG_REF);

	close(): void {
		this.dialogRef.close();
	}
}
